import { combineActions, handleActions } from 'redux-actions';

import { VerificationStatuses } from 'constants/verificationStatuses';
import { getCySecActiveStepByStatus } from '../helpers/getCySecActiveStepByStatus';
import { STEPPER_KEYS } from '../constants';
import { confirmQuestionnaireSuccess } from 'modules/cySecQuestionnaire/actions';
import { settingsVerificationUpdateSuccess } from '../../ProfileVerification/actions';
import {
  acceptTradeWithRestrictionsSuccess,
  changeStepForce,
  cySecVerificationPageOpened,
  cySecVerificationSecondStepUpdateSuccess,
  cySecVerificationUpdateSuccess,
  getVerificationUserSuccess,
  hideAccountSettingsCongratulations,
  hideAccountSettingsFeedback,
  hideCySecVerificationFeedback,
  redirectionToStartTrading,
  showAccountSettingsCongratulations,
  showAccountSettingsFeedback,
  showCySecVerificationFeedback,
  updatePersonalDetailsSuccess,
} from '../actions';

const defaultState = {
  activeStep: 0,
  newStep: 0,
  keepCurrentStep: false,
  showCySecVerificationFeedback: false,
  showAccountSettingsFeedback: false,
  showAccountSettingsCongratulations: false,
  redirectionToStartTrading: false,
};

export default handleActions(
  {
    [cySecVerificationPageOpened]() {
      return { ...defaultState };
    },
    [settingsVerificationUpdateSuccess](state) {
      return { ...state, showAccountSettingsCongratulations: true };
    },
    [cySecVerificationSecondStepUpdateSuccess](state) {
      return { ...state, showCySecVerificationFeedback: true };
    },
    [acceptTradeWithRestrictionsSuccess](state) {
      return { ...state, showAccountSettingsFeedback: false };
    },
    [combineActions(
      getVerificationUserSuccess,
      updatePersonalDetailsSuccess,
      cySecVerificationUpdateSuccess,
      cySecVerificationSecondStepUpdateSuccess,
      acceptTradeWithRestrictionsSuccess,
      confirmQuestionnaireSuccess,
      settingsVerificationUpdateSuccess,
    )](state, action) {
      const userInfo = action.response.data.user || action.response.data;
      let newState = {
        ...state,
        ...userInfo,
      };
      const passedCySecQuestionnaire = userInfo.cySecQuizProgress?.isPassed;
      const activeStep = userInfo.verification.activeStep;
      const status = userInfo.verification.status;
      const wasUserRejected = userInfo.verification.status === VerificationStatuses.REJECTED;
      const acceptedTradeWithRestrictions = userInfo.accountSettings?.acceptedTradeWithRestrictions;

      if (state.showCySecVerificationFeedback) {
        newState.activeStep = STEPPER_KEYS.DOCUMENTS;
      } else if (state.showAccountSettingsCongratulations) {
        newState.activeStep = STEPPER_KEYS.ACCOUNT;
      } else if (!wasUserRejected) {
        newState.activeStep = getCySecActiveStepByStatus(
          status,
          activeStep,
          passedCySecQuestionnaire,
          acceptedTradeWithRestrictions,
        );

        if (status === VerificationStatuses.EDITING.LEAD2 && !acceptedTradeWithRestrictions) {
          newState.showAccountSettingsFeedback = true;
        }
      } else if (wasUserRejected) {
        newState.activeStep = passedCySecQuestionnaire
          ? STEPPER_KEYS.DOCUMENTS
          : STEPPER_KEYS.EXPERIENCE;
      }
      return newState;
    },
    [changeStepForce](state, action) {
      return {
        ...state,
        activeStep: action.payload,
      };
    },
    [showCySecVerificationFeedback](state) {
      return {
        ...state,
        showCySecVerificationFeedback: true,
      };
    },
    [hideCySecVerificationFeedback](state) {
      return {
        ...state,
        showCySecVerificationFeedback: false,
      };
    },
    [showAccountSettingsFeedback](state) {
      return {
        ...state,
        showAccountSettingsFeedback: true,
      };
    },
    [hideAccountSettingsFeedback](state) {
      return {
        ...state,
        showAccountSettingsFeedback: false,
      };
    },
    [showAccountSettingsCongratulations](state) {
      return {
        ...state,
        showAccountSettingsCongratulations: true,
      };
    },
    [hideAccountSettingsCongratulations](state) {
      return {
        ...state,
        showAccountSettingsCongratulations: false,
      };
    },
    [redirectionToStartTrading](state) {
      return {
        ...state,
        redirectionToStartTrading: true,
      };
    },
  },
  defaultState,
);
